/**
 * Deliveries — every notification this workspace has sent, and whether it
 * arrived.
 *
 * DECISION-087, built inside Story 12.2 rather than as a story of its own:
 * "**a ninth nav destination, `/deliveries`**, workspace-scoped, rendering the
 * existing `DeliveryLog` component." Two things needed it and neither could
 * wait. `integrations.html` draws a `See all deliveries` link that Story 11.3
 * had to cut because it went nowhere (Q-063), and this story's feed makes every
 * item carry "the route that resolves it" — a workspace-wide "3 deliveries to
 * Email failed" has no single funnel to resolve to.
 *
 * IT IS THE SAME COMPONENT, DELIBERATELY. `DeliveryLog` was written for the
 * funnel editor's Connect tab in Story 9.5 and has always called
 * `/v1/w/{wid}/deliveries` with no funnel filter — it was workspace-wide from
 * the day it was written, and nobody noticed because until now it was the only
 * surface in the product that read deliveries at all. Here that is correct.
 * On the Connect tab it is not, and `docs/BACKLOG.md` carries that line.
 *
 * The page adds a heading and the sentence that says what the log is for, both
 * of which the card inside a tab did not need because its tab said them.
 *
 * Story 12.2 / DECISION-087.
 */
import { DeliveryLog } from '../editor/DeliveryLog'

export function Deliveries() {
  return (
    <div className="flex flex-col gap-mdx-24">
      <div className="flex flex-col gap-mdx-8">
        <h1 className="m-0 text-mdx-h1 font-mdx-bold leading-mdx-tight tracking-mdx-h1">
          Deliveries
        </h1>
        <p className="m-0 max-w-mdx-measure-52 text-mdx-15 leading-mdx-reason text-mdx-slate">
          Every notification this workspace has sent, newest first. A lead is captured, scored and
          in your leads list whether or not the send arrived.
        </p>
      </div>
      <DeliveryLog />
    </div>
  )
}
